import { useDeleteStreams as baseUseDeleteStreams } from '@vlabs/api/artemy/client';
import { toast } from 'react-toastify';

import { useDeleteStreamTranslation } from '../i18n';
import type { DeleteStreamsProps } from '../types';

export function useDeleteStreams({
  streamIds,
  onSuccess = undefined,
}: DeleteStreamsProps): {
    onDelete: VoidFunction;
    isPending: boolean;
  } {
  const { t } = useDeleteStreamTranslation();
  const deleteStreams = baseUseDeleteStreams({
    mutation: {
      onSuccess: () => {
        toast.success(t('on_success'));
        onSuccess?.();
      },
      onError: () => toast.error(t('on_error')),
    },
  });

  return {
    onDelete: () => deleteStreams.mutate({ data: { stream_ids: streamIds } }),
    isPending: deleteStreams.isPending,
  };
}
